import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import React from 'react'
import { CustomArrowProps } from 'react-slick'

export const SlickArrowRight = ({
    currentSlide,
    slideCount,
    ...props
}: CustomArrowProps) => (
    <ArrowForwardIosIcon
        {...props}
        className={
            'slick-next slick-arrow' +
            (slideCount && currentSlide === slideCount - 1
                ? ' slick-disabled'
                : '')
        }
        aria-hidden="true"
        aria-disabled={
            slideCount && currentSlide === slideCount - 1 ? true : false
        }
        fontSize="large"
    />
)

export const SlickArrowLeft = ({
    currentSlide,
    slideCount,
    ...props
}: CustomArrowProps) => (
    <ArrowBackIosIcon
        {...props}
        className={
            'slick-prev slick-arrow' +
            (currentSlide === 0 ? ' slick-disabled' : '')
        }
        aria-hidden="true"
        aria-disabled={currentSlide === 0 ? true : false}
        fontSize="large"
    />
)
